import script from "./table-screen-list.vue?vue&type=script&setup=true&lang=js"
export * from "./table-screen-list.vue?vue&type=script&setup=true&lang=js"

import "./table-screen-list.vue?vue&type=style&index=0&id=187e4210&scoped=true&lang=scss"

import exportComponent from "D:\\vsts-agent\\_work\\42\\s\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-187e4210"]])

export default __exports__